import { css } from "@emotion/css";
import { space } from "@octopusdeploy/design-system-tokens";
import React from "react";
import { QuickSkeleton } from "../components/QuickSkeleton";
const styles = {
    snapshotGrid: css({
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        padding: space[16],
        paddingTop: 0,
    }),
    snapshotGridRow: css({
        display: "flex",
        flexDirection: "row",
        gap: space[80],
    }),
    snapshotGridCell: css({
        height: "20px",
        width: "100%",
        flexGrow: 1,
        margin: space[8],
    }),
};
export const KubernetesSnapshotsLoadingSkeleton = () => (<div className={styles.snapshotGrid}>
        {[...new Array(7)].map((x, i) => (<div key={`gridRow-${i}`} className={styles.snapshotGridRow}>
                {[...new Array(5)].map((y, j) => (<div key={`gridCell-${j}`} className={styles.snapshotGridCell}>
                        <QuickSkeleton />
                    </div>))}
            </div>))}
    </div>);
